import React, { useMemo } from 'react';

import { ParentOKRComponent } from 'components/RabbitOKRSidePanel/Components/ParentOKRComponent';
import { RealignModal } from 'components/RabbitOKRSidePanel/Components/RealignModal';
import { useChangeTimelineRealignModalLogic } from 'components/RabbitOKRSidePanel/SecondaryPanel/RealignPanel/useChangeTimelineRealignModalLogic';
import { openSelectParentOKRPanel } from 'components/RabbitOKRSidePanel/krDrawerSecondaryPanelSlice';
import { useViewPageName } from 'components/Views/Hooks/useViewPageName';
import { useDispatch } from 'react-redux';

import { OKR_TYPES as OKR_TYPES_FROM_PROJECT_CONSTANTS } from 'constants/ProjectConstants';
import { sendClickedRealignedEvent } from 'constants/mixpanelHelper';

import InputLabel from 'uiToolkitV1/InputLabel';

export const OKR_TYPES = OKR_TYPES_FROM_PROJECT_CONSTANTS;

export const ParentOKR = ({
  okrText = '',
  okrVisibilityType,
  okrType,
  okrUuid,
  objectiveLevel,
  parentPost,
  timeBoundDetails,
  labelText = 'Parent',
  okrHasNoChildren,
  isReadOnly,
  showLabel = true,
  isOpenAsChild = false,
  leftPanelDetails,
}) => {
  const dispatch = useDispatch();
  const page = useViewPageName();
  const emptyParentPost = { uuid: null, text: 'None', type: null, visibilityType: null };
  parentPost = parentPost ?? emptyParentPost;

  const getSourceName = () => {
    if (okrUuid) {
      return okrType === OKR_TYPES.OBJECTIVE ? 'Edit Obj Panel' : 'Edit KR Panel';
    }
    return okrType === OKR_TYPES.OBJECTIVE ? 'Add Obj Panel' : 'Add KR Panel';
  };

  const payload = useMemo(
    () => ({
      parentUuid: parentPost?.uuid,
      parentText: parentPost?.text,
      parentType: parentPost?.type,
      parentVisibilityType: parentPost?.visibilityType,
      okrTimePeriod: timeBoundDetails,
      okrUuid,
      okrType,
      okrText,
      okrVisibilityType,
      objectiveLevel,
      okrHasNoChildren,
      eventType: 'Realign',
      source: getSourceName(),
    }),
    [
      okrHasNoChildren,
      okrText,
      okrType,
      okrUuid,
      okrVisibilityType,
      parentPost?.text,
      parentPost?.type,
      parentPost?.uuid,
      parentPost?.visibilityType,
      objectiveLevel,
      timeBoundDetails,
    ]
  );

  /* 
    Ideally this functionality can be extracted out and redux / context can be used.
    This requirement came a bit late and doing that will touch quite a few components, so doing it this way

    TODO: extract this hook and corresponding component to common component.
    use that component in one place and these components should only trigger opening and closing.
  */
  const {
    isChangeTimelineModalOpen,
    handleCloseModal,
    handleNotRealignChildrenOKRs,
    handleRealignChildrenOKRs,
    onSelectedTimeBoundPeriodChange,
  } = useChangeTimelineRealignModalLogic({
    details: isOpenAsChild ? { ...payload, isOpenAsChild, leftPanelDetails } : payload,
  });

  const handleRealignClick = () => {
    console.log('handleRealignClick clicked okrUuid', okrUuid);
    if (okrUuid) {
      sendClickedRealignedEvent({
        eventProperties: {
          source: okrType === OKR_TYPES.OBJECTIVE ? 'Edit Obj Panel' : 'Edit KR Panel',
          page,
          type: 'Realign',
          goalId: okrUuid,
        },
      });
      onSelectedTimeBoundPeriodChange(timeBoundDetails);
    } else {
      sendClickedRealignedEvent({
        eventProperties: {
          source: okrType === OKR_TYPES.OBJECTIVE ? 'Add Obj Panel' : 'Add KR Panel',
          page,
          type: 'Realign',
          goalId: okrUuid,
        },
      });
      dispatch(openSelectParentOKRPanel({ ...payload, isOpenAsChild, leftPanelDetails }));
    }
  };

  return (
    <>
      {showLabel ? (
        <InputLabel labelText={labelText} containerProps={{ whiteSpace: 'nowrap' }}>
          <ParentOKRComponent parentPost={parentPost} onClick={handleRealignClick} isReadOnly={isReadOnly} />
        </InputLabel>
      ) : (
        <ParentOKRComponent parentPost={parentPost} onClick={handleRealignClick} isReadOnly={isReadOnly} />
      )}
      <RealignModal
        isOpen={isChangeTimelineModalOpen}
        onClose={handleCloseModal}
        handleRealignChildrenOKRs={handleRealignChildrenOKRs}
        handleNotRealignChildrenOKRs={handleNotRealignChildrenOKRs}
        okrType={okrType}
      />
    </>
  );
};
